import { isNaN } from 'lodash'

export const isCurrency = (value: number) => {
  return typeof value === 'number' && !isNaN(value)
}
